import axios from '../utils/axios';

export default function deactivateSeekerPlan(adminId, body) {
    return axios.post(`/admin/${adminId}/jobseeker-admin/subscription/admin/deactivate-subscription?type=regular`, body);
};